import React from "react";
import classNames from "classnames";
import { Link } from "react-router";
import CSSModules from "lib/utils/css-modules";

import styles from "./SidebarView.less";

@CSSModules(styles)
class SidebarViewContainer extends React.PureComponent {
  static displayName = "SidebarView.Container";

  render() {
    return <div styleName="view">{this.props.children}</div>;
  }
}

@CSSModules(styles)
class SidebarViewSidebar extends React.PureComponent {
  static displayName = "SidebarView.Sidebar";

  handleToggleClick(event) {
    const { extended, onToggle } = this.props;
    event.preventDefault();
    onToggle && onToggle(!extended);
  }

  render() {
    const { label = "Menu", hasToggle = true, extended = true } = this.props;

    return (
      <div styleName={extended ? "sidebar--extended" : "sidebar--normal"}>
        <a styleName="sidebar-toggle" onClick={hasToggle && this.handleToggleClick.bind(this)} disabled={!hasToggle}>
          <span className="label">{label}</span>
        </a>

        <div styleName="sidebar-content">{this.props.children}</div>
      </div>
    );
  }
}

@CSSModules(styles)
class SidebarViewContent extends React.PureComponent {
  static displayName = "SidebarView.Content";

  render() {
    const { hasSidebar = true } = this.props;

    return <div styleName={hasSidebar ? "content-with-sidebar" : "content"}>{this.props.children}</div>;
  }
}

@CSSModules(styles)
class SidebarViewMenu extends React.PureComponent {
  static displayName = "SidebarView.Menu";

  render() {
    const { links, activePath } = this.props;

    const isLinkActive = (link) => link.active || (activePath && activePath === link.path);

    const renderLink = ({ visible = true, ...link }) => {
      const linkContent = (
        <span>
          {link.icon} {link.label} {!!link.error && <i className="fa fa-exclamation-circle"></i>}
        </span>
      );
      return (
        <li
          key={link.key || link.path}
          hidden={!visible}
          className={classNames({
            active: isLinkActive(link) || (link.children && link.children.find(isLinkActive)),
            error: link.error,
          })}
        >
          {link.path && (
            <Link as="a" to={link.path} onClick={link.onClick}>
              {linkContent}
            </Link>
          )}
          {!link.path && (
            <a onClick={link.onClick} className={link.onClick ? "" : "inactive"}>
              {linkContent}
            </a>
          )}
          {link.children && <ul>{link.children.map(renderLink)}</ul>}
        </li>
      );
    };

    return (
      <div styleName="menu">
        <ul>{links.map(renderLink)}</ul>
      </div>
    );
  }
}

export default {
  Container: SidebarViewContainer,
  Sidebar: SidebarViewSidebar,
  Content: SidebarViewContent,
  Menu: SidebarViewMenu,
};



// WEBPACK FOOTER //
// ./src/lib/components/SidebarView.jsx